import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty"; // waitlist visibility api types

import { getGUID, getTimeInUTC } from "./util";
import { UIError } from "./errors";
import i18next from "i18next";

var Waitlist = /*#__PURE__*/function () {
  function Waitlist(config, axios) {
    _classCallCheck(this, Waitlist);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Waitlist, [{
    key: "createWaitlistUser",
    value: function () {
      var _createWaitlistUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var _this = this;

        var firstName, lastName, email, phoneNumber, partySize, restaurantNum, eclubOptin, signUpSource, commonQueryParams, locale, reqBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firstName = payload.firstName, lastName = payload.lastName, email = payload.email, phoneNumber = payload.phoneNumber, partySize = payload.partySize, restaurantNum = payload.restaurantNum, eclubOptin = payload.eclubOptin, signUpSource = payload.signUpSource;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = {
                  restaurantNum: restaurantNum,
                  partySize: partySize,
                  eclubOptin: eclubOptin,
                  type: eclubOptin ? "subscription" : null,
                  subscriptionStatus: eclubOptin ? "P" : null,
                  signUpSource: signUpSource,
                  userDetail: {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    phoneNumber: phoneNumber
                  }
                };
                _context.next = 6;
                return this.axios.post(this.config.postfix.WAITLIST, reqBody, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this._processWaitListInfo(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createWaitlistUser(_x) {
        return _createWaitlistUser.apply(this, arguments);
      }

      return createWaitlistUser;
    }()
  }, {
    key: "editWailist",
    value: function () {
      var _editWailist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var _this2 = this;

        var waitListId, partySize, email, lastName, firstName, phoneNumber, commonQueryParams, locale, reqBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                waitListId = payload.waitListId, partySize = payload.partySize, email = payload.email, lastName = payload.lastName, firstName = payload.firstName, phoneNumber = payload.phoneNumber;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = {
                  waitlistId: waitListId,
                  partySize: partySize,
                  userDetail: {
                    email: email,
                    lastName: lastName,
                    firstName: firstName,
                    phoneNumber: phoneNumber
                  }
                };
                _context2.next = 6;
                return this.axios.put(this.config.postfix.WAITLIST, reqBody, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this2._processWaitListInfo(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editWailist(_x2) {
        return _editWailist.apply(this, arguments);
      }

      return editWailist;
    }()
  }, {
    key: "getWaitTime",
    value: function () {
      var _getWaitTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var _this3 = this;

        var restaurantNum, commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                restaurantNum = payload.restaurantNum;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context3.next = 5;
                return this.axios.get(this.config.postfix.GET_WAIT_TIME, {
                  params: {
                    restaurantNum: restaurantNum,
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this3 === null || _this3 === void 0 ? void 0 : _this3._processWaitTime(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getWaitTime(_x3) {
        return _getWaitTime.apply(this, arguments);
      }

      return getWaitTime;
    }()
  }, {
    key: "getWaitlistDetails",
    value: function () {
      var _getWaitlistDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        var _this4 = this;

        var waitListId, commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                waitListId = payload.waitListId;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context4.next = 5;
                return this.axios.get(this.config.postfix.GET_WAITLIST.replace("{waitListId}", waitListId), {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this4._processWaitListInfo(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getWaitlistDetails(_x4) {
        return _getWaitlistDetails.apply(this, arguments);
      }

      return getWaitlistDetails;
    }()
  }, {
    key: "deleteWaitlistDetails",
    value: function () {
      var _deleteWaitlistDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var _this5 = this;

        var waitListId, commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                waitListId = payload.waitListId;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context5.next = 5;
                return this.axios["delete"](this.config.postfix.GET_WAITLIST.replace("{waitListId}", waitListId), {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this5._processCancelWaitlist(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteWaitlistDetails(_x5) {
        return _deleteWaitlistDetails.apply(this, arguments);
      }

      return deleteWaitlistDetails;
    }() // waitlist api's proccess functions

  }, {
    key: "_processWaitListInfo",
    value: function _processWaitListInfo(resp) {
      var _resp$data, _resp$data3, _resp$data4;

      if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.errors) {
        var _resp$data2;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.errors
        };
      }

      if ((resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.statusCode) === 204) {
        throw new Error(i18next.t("errors.waitlist.expired", {
          defaultValue: "This Waitlist has expired."
        }));
      }

      return resp === null || resp === void 0 ? void 0 : (_resp$data4 = resp.data) === null || _resp$data4 === void 0 ? void 0 : _resp$data4.waitListInfo;
    }
  }, {
    key: "_processWaitTime",
    value: function _processWaitTime(resp) {
      var _resp$data5, _resp$data7;

      if (resp !== null && resp !== void 0 && (_resp$data5 = resp.data) !== null && _resp$data5 !== void 0 && _resp$data5.errors) {
        var _resp$data6;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data6 = resp.data) === null || _resp$data6 === void 0 ? void 0 : _resp$data6.errors
        };
      }

      return resp === null || resp === void 0 ? void 0 : (_resp$data7 = resp.data) === null || _resp$data7 === void 0 ? void 0 : _resp$data7.waitTimeDetail;
    }
  }, {
    key: "_processCancelWaitlist",
    value: function _processCancelWaitlist(resp) {
      var _resp$data8, _resp$data10, _resp$data10$waitList;

      if (resp !== null && resp !== void 0 && (_resp$data8 = resp.data) !== null && _resp$data8 !== void 0 && _resp$data8.errors) {
        var _resp$data9;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data9 = resp.data) === null || _resp$data9 === void 0 ? void 0 : _resp$data9.errors
        };
      }

      if ((resp === null || resp === void 0 ? void 0 : (_resp$data10 = resp.data) === null || _resp$data10 === void 0 ? void 0 : (_resp$data10$waitList = _resp$data10.waitListInfo) === null || _resp$data10$waitList === void 0 ? void 0 : _resp$data10$waitList.status) === "cancelled") {
        return true;
      }

      return false;
    } // waitlist visibility api calls

  }, {
    key: "getVisitByVisitID",
    value: function () {
      var _getVisitByVisitID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
        var concept, corporationId, locationNumber, visitId, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                concept = payload.concept, corporationId = payload.corporationId, locationNumber = payload.locationNumber, visitId = payload.visitId;
                _context6.next = 3;
                return this.axios.get(this.config.postfix.GET_VISIT_BY_VISIT_ID, {
                  params: {
                    corpCode: corporationId,
                    locNumber: locationNumber,
                    visitID: visitId
                  },
                  headers: {
                    Concept: concept,
                    CorporationID: corporationId,
                    LocationNumber: locationNumber,
                    channel: "MICROSITE",
                    sourceSystem: "DP",
                    timestamp: getTimeInUTC(),
                    trackingID: getGUID()
                  }
                });

              case 3:
                response = _context6.sent;
                return _context6.abrupt("return", response.data);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getVisitByVisitID(_x6) {
        return _getVisitByVisitID.apply(this, arguments);
      }

      return getVisitByVisitID;
    }()
  }, {
    key: "getVisitByToken",
    value: function () {
      var _getVisitByToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
        var tokenId, concept, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                tokenId = payload.tokenId, concept = payload.concept;
                _context7.next = 3;
                return this.axios.get(this.config.postfix.GET_VISIT_BY_TOKEN, {
                  params: {
                    tokenID: tokenId
                  },
                  headers: {
                    Concept: concept,
                    timestamp: getTimeInUTC(),
                    sourceSystem: "DP",
                    channel: "MICROSITE",
                    trackingID: getGUID()
                  }
                });

              case 3:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getVisitByToken(_x7) {
        return _getVisitByToken.apply(this, arguments);
      }

      return getVisitByToken;
    }()
  }, {
    key: "checkInVisit",
    value: function () {
      var _checkInVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
        var corporationId, visitId, concept, locationNumber, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                corporationId = payload.corporationId, visitId = payload.visitId, concept = payload.concept, locationNumber = payload.locationNumber;
                _context8.next = 3;
                return this.axios.post(this.config.postfix.CHECK_IN_VISIT, {
                  header: {
                    sourceSystem: "DP",
                    channel: "MICROSITE",
                    timestamp: getTimeInUTC(),
                    trackingID: getGUID(),
                    location: {
                      corporationID: corporationId,
                      number: locationNumber,
                      concept: concept
                    }
                  },
                  location: {
                    corporationID: corporationId,
                    number: locationNumber
                  },
                  visitID: visitId
                }, {
                  headers: {
                    CorporationID: corporationId,
                    LocationNumber: locationNumber,
                    Concept: concept
                  }
                });

              case 3:
                response = _context8.sent;
                return _context8.abrupt("return", response.data);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function checkInVisit(_x8) {
        return _checkInVisit.apply(this, arguments);
      }

      return checkInVisit;
    }()
  }, {
    key: "cancelVisit",
    value: function () {
      var _cancelVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
        var corporationId, visitId, concept, locationNumber, checkVisitArrivalStatus, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                corporationId = payload.corporationId, visitId = payload.visitId, concept = payload.concept, locationNumber = payload.locationNumber, checkVisitArrivalStatus = payload.checkVisitArrivalStatus;
                _context9.next = 3;
                return this.axios.post(this.config.postfix.CANCEL_VISIT, {
                  header: {
                    sourceSystem: "DP",
                    channel: "MICROSITE",
                    timestamp: getTimeInUTC(),
                    trackingID: getGUID(),
                    location: {
                      corporationID: corporationId,
                      number: locationNumber,
                      concept: concept
                    }
                  },
                  location: {
                    corporationID: corporationId,
                    number: locationNumber
                  },
                  visitID: visitId,
                  checkVisitArrivalStatus: checkVisitArrivalStatus
                }, {
                  headers: {
                    CorporationID: corporationId,
                    LocationNumber: locationNumber,
                    Concept: concept
                  }
                });

              case 3:
                response = _context9.sent;
                return _context9.abrupt("return", response.data);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function cancelVisit(_x9) {
        return _cancelVisit.apply(this, arguments);
      }

      return cancelVisit;
    }()
  }]);

  return Waitlist;
}();

export { Waitlist as default };